// extracted by mini-css-extract-plugin
export var component = "ContactBlock-module--component--RRLn6";